import { graphql } from "../generated";

export const GET_SHOW = graphql(`
  query GetShow($showId: ID!) {
    show(id: $showId) {
      id
      displayTitle
      displayDescription
      displayHorizontalThumbnail {
        original
      }
      displayImage {
        original
      }
      # The paywall's first poster is the show being watched (SHO-766).
      displayThumbnail {
        original
      }
      likes
      bookmarks
      episodesCount
      title
      publishedAt
      createdAt
      unlisted
      episodes {
        id
        number
        # No likes: Like / Unlike write it, see GetShowLikeState (SHO-824).
        url
        free
      }
    }
  }
`);
